import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SdexAdminService {
  constructor(private readonly http: HttpClient) {}

  editUser(id: any, payload: any) {
    let url = environment.BASE_URL + '/v1/user/' + id;
    return this.http.put(url, payload);
  }

  getUserList(companyId: any) {
    let url = environment.BASE_URL + '/v1/user/company/'+companyId;
    return this.http.get(url);
  }

  getRootCompanyUsers() {
    let url = environment.BASE_URL + '/v1/user';
    return this.http.get(url);
  }
  getRootCompanyUsers1(filters : any) {
    let url = environment.BASE_URL + '/v1/user';
    return this.http.get(url,{params : filters});
  }

  editCompanyPrefrenceAddressorLogo(data: any, companyId: any) {
    let url = environment.BASE_URL + '/v1/company-preference/' + companyId;
    return this.http.post(url, data);
  }

  assignCompany(payload: any, userId: any) {
    let url = environment.BASE_URL + '/v1/user/assign/' + userId;
    return this.http.put(url, payload);
  }

  getAssignedUserCompany(userId: any) {
    let url = environment.BASE_URL + '/v1/company/assign/' + userId;
    return this.http.get(url);
  }

  getUserById(id: any) {
    let url = environment.BASE_URL + '/v1/user/' + id;
    return this.http.get(url);
  }

  contactVisibleTo(companyId: any) {
    let params = new HttpParams();
    params = params.append('company', companyId);
    let url = environment.BASE_URL + '/v1/user';
    return this.http.get(url, { params: params });
  }

  createContact(payload: any) {
    let url = environment.BASE_URL + '/v1/company-contacts';
    return this.http.post(url, payload);
  }

  getContactList(companyId: any) {
    let params = new HttpParams();
    params = params.append('company', companyId);
    let url = environment.BASE_URL + '/v1/contacts';
    return this.http.get(url, { params: params });
  }

  addUser(data: any) {
    let url = environment.BASE_URL + '/v1/user';
    return this.http.post(url, data);
  }

  addCompanyUser(data: any,id:any) {
    let url = environment.BASE_URL + `/v1/user/sub-company-user`;
    return this.http.post(url,data);
  }

  getCompanyDataById(companyId: any) {
    let url = environment.BASE_URL + `/v1/company/${companyId}`;
    return this.http.get(url);
  }

  addContact(payload: any) {
    let url = environment.BASE_URL + '/v1/contacts';
    return this.http.post(url, payload);
  }

  getCompanyPreferenceByCompanyId(companyId: any) {
    let url = environment.BASE_URL + '/v1/company-preference/' + companyId;
    return this.http.get(url);
  }

  getUserListByCompanyId(filters: any) {
    let url = environment.BASE_URL + '/v1/user/sub-company-users';
    return this.http.get(url, { params: filters });
  }

  // uploadFile(payload: any): Observable<any> {
  //   return this.http.post(
  //     environment.BASE_URL + `/v1/digilocker/public-file/upload`,
  //     payload
  //   );
  // }
  uploadFile(payload: any): Observable<any> {
    return this.http.post(
      environment.BASE_URL + `/v1/logo-upload`,
      payload
    );
  }

  acceptInvitation(id: any) {
    let url = environment.BASE_URL + `/v1/contacts/accept/${id}`;
    return this.http.put(url, '');
  }

  rejectInvitation(id: any) {
    let url = environment.BASE_URL + `/v1/contacts/reject/${id}`;
    return this.http.put(url, '');
  }
  deleteUser(id: any) {
    let url = environment.BASE_URL + `/v1/user/delete/${id}`;
    return this.http.delete(url);
  }

  getAllUsers(params: any) {
    let url = environment.BASE_URL + `/v1/user/all-users`;
    return this.http.get(url, { params: params });
  }
}
